export enum FeeType {
    Paint = 'paint',
    Repair = 'repair',
    Replacement = 'replacement',
}

export const FeeTypeLabel: Record<FeeType, string> = {
    [FeeType.Paint]: 'Peinture',
    [FeeType.Repair]: 'Réparation',
    [FeeType.Replacement]: 'Remplacement',
}
